import { lowerCase } from 'lodash'
import ReactGA from 'react-ga4'
import { makeAutoObservable } from 'mobx'
import StoreCountry from 'GlobalStores/Cores/County/StoreCountry'
class TrackingEvents {
    get trackingPages() {
        return [
            'menu',
            'commission',
            'orderhistory',
            'seminars',
            'bmi',
            'marketing-artwork',
            'digital-member-card',
            'settings',
            'genealogy/table',
            'genealogy/dashboard',
            'genealogy/card',
            'genealogy/level',
            'shopping',
            'catproduct/all',
            'feedback',
            'cart',
            'checkout',
            'ordersummary',
            'checkout/summary',
            'checkout/payment-response/success',
            'checkout/payment-response/failed',
            'reports',
            'something-went-wrong'
        ]
    }

    GAInitialize(fullCountryName) {
        let GACode = StoreCountry.GA4MeasurementID[lowerCase(StoreCountry.CountryCapitalize())]
        let GACodeAll = StoreCountry.GA4MeasurementID.allmarket

        const eachMarket = lowerCase(StoreCountry.CountryCapitalize())
        const allMarketName = 'USHOP-FEELGREAT (all market)'
        const trackers = [
            {
                trackingId: GACodeAll,
                gaOptions: { name: allMarketName }
            },
            {
                trackingId: GACode,
                gaOptions: { name: eachMarket }
            }
        ]

        ReactGA.gtag('config', '6250135487', {
            page_title: `USHOP-FEELGREAT - ${lowerCase(StoreCountry.CountryCapitalize())}`,
            page_location: window.location.href
        })

        ReactGA.initialize(trackers)
    }

    CommitToGoogleAnalytic(label, category, action, fullCountryName, interAction) {
        const MeasurementIDAll = StoreCountry.GA4MeasurementID.allmarket
        const eachMarket = StoreCountry.GA4MeasurementID[lowerCase(StoreCountry.CountryCapitalize())]
        const marketName = lowerCase(StoreCountry.CountryCapitalize())
        const trackings = [
            {
                trackingId: MeasurementIDAll,
                gaOptions: {
                    name: 'USHOP-FEELGREAT (ALL MARKET)'
                }
            },
            {
                trackingId: eachMarket,
                gaOptions: {
                    name: marketName
                }
            }
        ]
        ReactGA.initialize(trackings)
    }

    // Ecommerce
    CommitECAction(action, actionType, payload) {
        ReactGA.plugin.execute('ec', action, actionType, payload)
        ReactGA.plugin.execute('ec', 'send')
    }
    // Ecommerce Clear
    EcommerceClear(page) {
        ReactGA.pageview(page)
        ReactGA.plugin.execute('ec', 'clear')
    }

    ViewItems(eventType) {
        ReactGA.event('view_item', eventType)
    }

    AddToCart(eventType, param) {
        ReactGA.event('add_to_cart', eventType, param)
    }

    PurchaseEvent(params) {
        ReactGA.event('purchase', params)
        ReactGA.gtag('purchase', params.eventType)
    }

    PurchaseJourney({ eventType, fullCountryName, value = 0.0, productItems = [], referalId = 'none', eventId = '' }) {
        this.GAInitialize(fullCountryName)
        const trackingData = {
            currency: StoreCountry.GetCurrencyCode(),
            value: value, //total price
            items: productItems,
            referal_id: referalId,
            event_id: eventId,
            debug_mode: true
        }

        ReactGA.gtag('event', eventType.toLowerCase(), trackingData)
    }

    BeginCheckout(fullCountryName = 'allMarkets', eventType, items, value, referalId = 'none', event_id) {
        this.GAInitialize(fullCountryName)
        const params = {
            ecommerce: {
                currency: StoreCountry.GetCurrencyCode(),
                value: value,
                items: items
            },
            event_id: event_id,
            referal_id: referalId
        }
        ReactGA.gtag('event', eventType, params)

        ReactGA.gtag('begin_checkout', eventType, params)
        ReactGA.event('begin_checkout', eventType ,params)
    }

    Commit(fullCountryName) {
        const MeasurementIDAll = StoreCountry.GA4MeasurementID.allmarket
        const eachMarket = StoreCountry.GA4MeasurementID[fullCountryName]
        const marketName = fullCountryName
        const trackings = [
            {
                trackingId: MeasurementIDAll,
                gaOptions: {
                    name: 'USHOP-FEELGREAT (ALL MARKET)'
                }
            },
            {
                trackingId: eachMarket,
                gaOptions: {
                    name: marketName
                }
            }
        ]

        ReactGA.initialize(trackings)
    }

    get CATEGORY() {
        return {
            PAGE_VIEW: 'Page View',
            EXTERNAL_LINK: 'External Link'
        }
    }

    get ACTION() {
        return {
            CLICK: 'click',
            VIEW: 'view',
            MOBILE_CLICK: 'click via mobile',
            MOBILE_VIEW: 'view on mobile',
            SETACTION: 'setAction'
        }
    }
    get ACTION_TYPE() {
        return {
            ADD_PRODUCT: 'addProduct',
            REMOVE_PRODUCT: 'removeProduct',
            CHECKOUT: 'checkout',
            CLEAR_CART: 'clearcart'
        }
    }

    get EVENT_TYPE() {
        return {
            ADD_ITEM: 'ADD_ITEM',
            REMOVE_ITEM: 'REMOVE_ITEM',
            PURCHASE: 'PURCHASE',
            CLEAR_CART: 'CLEAR_CART',
            VIEW_ITEM: 'VIEW_ITEM',
            ADD_TO_CART: 'ADD_TO_CART',
            BEGIN_CHECKOUT: 'BEGIN_CHECKOUT',
        }
    }

    constructor() {
        makeAutoObservable(this)
    }
}
const trackingEvents = new TrackingEvents()
export default trackingEvents
